// extracted by mini-css-extract-plugin
module.exports = {"root":"RevisionsList__root--3uCDk"};